import { render, staticRenderFns } from "./RemoveItem.vue?vue&type=template&id=440a4162&"
import script from "./RemoveItem.vue?vue&type=script&lang=js&"
export * from "./RemoveItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports